import React from 'react'
import { Badge } from 'reactstrap'
import { Link } from 'react-router-dom'
import { Avatar } from '../../Components/Common'

export const studentColumns = (layout, role) => [
	{
		name: 'Avatar',
		selector: (row) => row.avatar_url,
		sortable: false,
		width: '80px',
		cell: (row) => (
			<div className="d-flex align-items-center">
				<Avatar avatar_url={row.avatar_url} id={row.id} layout={layout} role={role} entityType="students" className="cursor-pointer text-black" />
			</div>
		)
	},
	{
		name: 'Name',
		selector: (row) => row.name || '',
		sortable: true,
		cell: (row) => (
			<div>
				<Link to={`${process.env.PUBLIC_URL}/${role}/students/detail/${row.id}/${layout}`} className="text-decoration-none cursor-pointer text-black">
					<div>{row.name + ' ' + row.surname || 'N/A'}</div>
				</Link>
			</div>
		)
	},
	{
		name: 'School',
		selector: (row) => row.schoolname || '',
		sortable: true,
		cell: (row) => (
			<div className="text-truncate" style={{ maxWidth: '200px' }}>
				{row.schoolname || 'N/A'}
			</div>
		)
	},
	{
		name: 'Grade',
		selector: (row) => row.class || '',
		sortable: true,
		cell: (row) => (
			<Badge color="info" className="px-2 py-1">
				{row.class || 'N/A'}
			</Badge>
		)
	},
	{
		name: 'Status',
		selector: (row) => row.isActive,
		sortable: true,
		cell: (row) => (
			<Badge color={row.isActive ? 'success' : 'secondary'} className="px-2 py-1">
				{row.isActive ? 'Active' : 'Inactive'}
			</Badge>
		)
	}
]
